var ua = navigator.userAgent;
var uaPad = window.navigator.userAgent.toLowerCase();
var scroll;
var winW;
var scrollTop;

if (
  ua.indexOf("iPhone") > 0 ||
  ua.indexOf("iPod") > 0 ||
  (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
) {
  ua = "sp";
} else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
  ua = "tab";
} else {
  ua = "pc";
}
if (
  uaPad.indexOf("ipad") > -1 ||
  (uaPad.indexOf("macintosh") > -1 && "ontouchend" in document)
) {
  ua = "tab";
}

$(function () {
  setGlobalNavi();
  setProductLabel();
  setFeaturedPrice();
  setSearchCount();
  setSizeSpec();
  setCartCaution();
});

// グローバルナビゲーション
function setGlobalNavi() {
  $("#header .menu").click(function () {
    scrollTop = $(window).scrollTop();
    $("body").addClass("nav_open").css({
      top: -scrollTop,
    });
    $("#header").removeClass("header--hidden");
    $("#header").addClass("header--visible");
  });
  $("#header .close, #header .gnav_bg").click(function () {
    $("body").removeClass("nav_open").css({
      top: "",
    });
    $("#header").removeClass("header--hidden");
    $(window).scrollTop(scrollTop);
  });
}

// 商品バリエーションSIZE
function setProductLabel() {
  $(".product-form__swatch__label").each(function () {
    var swatchLabel = $(this).html();
    if (swatchLabel.indexOf("(SMALL)") >= 0) {
      $(this).html("SIZE 1<br>(SMALL)");
    }
    if (swatchLabel.indexOf("(MEDIUM)") >= 0) {
      $(this).html("SIZE 2<br>(MEDIUM)");
    }
    if (swatchLabel.indexOf("(LARGE)") >= 0) {
      $(this).html("SIZE 3<br>(LARGE)");
    }
    if (swatchLabel.indexOf("(X-LARGE)") >= 0) {
      $(this).html("SIZE 4<br>(X-LARGE)");
    }
  });
}

function setFeaturedPrice() {
  $(".product-featured__price-number .money").after("(Tax inc.)");
}

function setSearchCount() {
  var searchkeywordWidth = $(".search_keyword").width() + 20;
  $(".product_count").css("left", searchkeywordWidth + "px");
}

function setCartCaution() {
  $(".minmaxify-ok").css({
    background: "#000",
  });

  $(".minmaxify-p").css({
    padding: "30px",
    position: "relative",
  });

  $(".minmaxify-p ul").css({
    margin: "20px 0",
  });

  $(".minmaxify-close").css({
    position: "absolute",
    background: "#000",
    top: "20px",
    right: "10px",
  });
}

//商品ページSIZE SPEC
function setSizeSpec() {
  if ($(".product-single__content-text table").length) {
    $(".product-single__content-text table").addClass(
      "product-info-size-table",
    );
    $(".product-single__content-text table")
      .parent()
      .addClass("product-info-size");
    var productInfoTable = $(".product-info-size").html();
    $(".product-single__content-text table").remove();
    // $(".product-info-size").prepend("<div class='product-info-size-box'></div>");
    // $(".product-info-size").prepend("<div class='product-info-overlay'></div>");
    $("body").append("<div class='product-info-size-box'></div>");
    $("body").append("<div class='product-info-overlay'></div>");
    $(".product-info-size-box").prepend(
      "<h3 class='product-info-size-title'>SIZE SPEC</h3>",
    );
    $(".product-info-size-box").append(productInfoTable);
    $(".product-info-size-box").css("display", "none");
    // $(".product-single__content-text").append('<p class="product-sizespec"><a>SIZE SPEC</a></p>');
  } else {
    $(".product-sizespec").css({
      display: "none",
    });
  }
  $(".product-sizespec a").on("click", function () {
    $(".product-info-size-box").fadeIn();
    $(".product-info-overlay").fadeIn();
  });
  $(".product-info-overlay").on("click", function () {
    $(".product-info-size-box").fadeOut();
    $(".product-info-overlay").fadeOut();
  });
}
